// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"638":"60d780f0","703":"5e5b4c22","968":"010faa97"}[chunkId] + ".chunk.js";
};